/**
 * CPA Template — Static Asset References
 *
 * Skin-specific image and asset exports.
 * Kept in the template boundary so asset ownership stays local to the skin
 * instead of leaking into shared runtime config.
 *
 * `img` is a webpack alias that resolves to src_unified/templates/cpa/img/ when SKIN=cpa.
 * See webpack.config.js alias configuration.
 */

export const cap = require("img/offers/default.jpg");

export const brand = {
    logo: require('img/main-logo.svg'),
    logoExtended: require('img/main-logo-exteneded.svg'),
};

export const icons = {
    cross: require('img/cross.svg'),
    error404: require('img/icons/404.svg'),
    filter: require('img/offers/filter.svg'),
    downArrow: require('img/icons/down-arrow.svg'),
    settings: require('img/icons/settings.svg'),
};

export const chart = {
    hide: require('img/chart/chart-hide.svg'),
    show: require('img/chart/chart-show.svg'),
    bar: require('img/chart/chart-bar.svg'),
    line: require('img/chart/chart-line.svg'),
};

export const navIcons = {
    home: require('img/icons/home.svg'),
    offers: require('img/icons/offers.svg'),
    statistics: require('img/icons/statistics.svg'),
    finance: require('img/icons/finance.svg'),
    instruments: require('img/icons/instruments.svg'),
    information: require('img/icons/information.svg'),
    arrowNav: require('img/icons/arrow_nav.svg'),
};

export const locales = [
    {
        key: "uk",
        name: "UK",
        image: require("img/flags/4x3/uk.svg"),
    },
    {
        key: "en",
        name: "EN",
        image: require("img/flags/4x3/en.svg"),
    },
    {
        key: "ru",
        name: "RU",
        image: require("img/flags/4x3/ru.svg"),
    },
];
